module.exports = __webpack_public_path__ + "img/destina.d380e982.webp";